module.exports = __webpack_public_path__ + "img/icon-fb.ecb9e450.svg";